import React from "react";
import Filter from "./Filter";

export default function FilterSection(props) {

    const { filters,
        appliedFilters,
        handleFilterChange } = props;

    return (
        <div className="filter-sections">
            {
                filters.map((filter, i) => (
                    <Filter key={`filter-${i}`} filter={filter} appliedFilters={appliedFilters}
                        handleFilterChange={handleFilterChange} />
                ))
            }
        </div>
    );
}